import { PaperTypeEnum } from "commons/enum/paper-type";
import { OptionItem } from "commons/ultilities/dynamic-form/models/control";

export * from "./paper-material-group-selection-connected";

export const getPaperTypeOptions = (): OptionItem[] => {
  return [
    {
      value: PaperTypeEnum.Ivory,
      label: "Ivory",
    },
    {
      value: PaperTypeEnum.IvoryFSCMixCredit,
      label: "Ivory FSC Mix Credit",
    },
    {
      value: PaperTypeEnum.IvoryFSCMix70,
      label: "Ivory FSC Mix 70%",
    },
    {
      value: PaperTypeEnum.Duplex,
      label: "Duplex",
    },
    {
      value: PaperTypeEnum.DuplexFSCMixCredit,
      label: "Duplex FSC Mix Credit",
    },
    {
      value: PaperTypeEnum.DuplexFSCMix70,
      label: "Duplex FSC Mix 70%",
    },
    {
      value: PaperTypeEnum.Duplex2S,
      label: "Duplex (2S)",
    },
    {
      value: PaperTypeEnum.Couche,
      label: "Couche",
    },
    {
      value: PaperTypeEnum.Forte,
      label: "Forte",
    },
    {
      value: PaperTypeEnum.Kraft,
      label: "Kraft",
    },
    {
      value: PaperTypeEnum.Other,
      label: "Khác",
    },
  ];
};

export const getPaperTypeOptionLabel = (value: string): string => {
  const option = getPaperTypeOptions().find((o) => o.value === value);
  return option ? option.label : "";
};

export const getPaperPaperSpecificationTypeOptions = (): OptionItem[] => {
  return [
    {
      value: "Roll",
      label: "Cuồn",
    },
    {
      value: "Ram",
      label: "Ram",
    },
    {
      value: "Other",
      label: "Khác",
    },
  ];
};

export const getPaperSpecificationTypeOptionLabel = (value: string): string => {
  const option = getPaperPaperSpecificationTypeOptions().find(
    (o) => o.value === value,
  );
  return option ? option.label : "";
};
